import { useState } from "react";

import SearchForm from "../../components/SearchForm";
import SessionResults from "../../components/SessionResults";
import { INITIAL_SESSION_SEARCH_DATA } from "../../constants/searchSessions";
import { useCourtSessionOptions } from "../../hooks/useCourtSessionOptions";
import {
  useSessionSearch,
  validateSessionSearch,
} from "../../hooks/useSessionSearch";
import type { SearchData, SearchMode } from "../../types";

const SearchSessions = () => {
  const [searchMode, setSearchMode] = useState<SearchMode>("cnr");
  const [searchData, setSearchData] = useState<SearchData>(
    INITIAL_SESSION_SEARCH_DATA,
  );
  const [hasSearched, setHasSearched] = useState(false);

  const {
    states,
    highCourts,
    benches,
    benchRooms,
    districts,
    complexes,
    establishments,
    courtRooms,
    courtEstablishment,
    controls,
  } = useCourtSessionOptions(searchData, searchMode);

  const {
    results,
    setResults,
    proceedingData,
    isSearching,
    isPaginating,
    page,
    totalPages,
    total,
    handleSearch,
    handlePageChange,
    resetSearchResults,
  } = useSessionSearch(searchData, searchMode);
  console.log(results, "check results");

  const handleSearchModeChange = (mode: SearchMode) => {
    setSearchMode(mode);
    setHasSearched(false);
    setSearchData({
      ...INITIAL_SESSION_SEARCH_DATA,
      date: searchData.date,
    });
    resetSearchResults();
  };

  const handleSessionSearch = () => {
    if (validateSessionSearch(searchData, searchMode)) {
      console.log(searchData, "check search data");

      setHasSearched(true);
    }

    handleSearch();
  };

  const handleInputChange = (field: keyof SearchData, value: string) => {
    setSearchData((prev) => ({
      ...prev,
      [field]: field === "status" ? value || undefined : value,

      ...(field === "highcourt" && {
        bench: "",
        benchRoom: "",
      }),

      ...(field === "state" && {
        district: "",
        courtComplex: "",
        establishment: "",
        courtName: "",
      }),

      ...(field === "bench" && {
        benchRoom: "",
      }),

      ...(field === "district" && {
        courtComplex: "",
        establishment: "",
        courtName: "",
      }),

      ...(field === "courtComplex" && {
        establishment: "",
        courtName: "",
      }),

      ...(field === "establishment" && {
        courtName: "",
      }),
    }));
  };

  return (
    <div className="min-h-screen w-full">
      <div className="w-full max-w-full p-4">
        <SearchForm
          searchMode={searchMode}
          searchData={searchData}
          isSearching={isSearching}
          onSearchModeChange={handleSearchModeChange}
          onInputChange={handleInputChange}
          onSearch={handleSessionSearch}
          districts={districts}
          states={states}
          complexes={complexes}
          establishments={establishments}
          courtRooms={courtRooms}
          highCourts={highCourts}
          benches={benches}
          benchRooms={benchRooms}
          courtEstablishment={courtEstablishment}
          courtOptionControls={controls}
        />

        <SessionResults
          results={results}
          proceedingData={proceedingData}
          isLoading={isSearching || isPaginating}
          hasSearched={hasSearched}
          setResults={setResults}
          setSearchData={setSearchData}
          onPageChange={handlePageChange}
          page={page}
          totalPages={totalPages}
          total={total}
          searchMode={searchMode}
        />
      </div>
    </div>
  );
};

export default SearchSessions;
